module.exports = __webpack_public_path__ + "89aac662cc303834cef7126ef4659570.svg";